import { ReportBlockPreview } from '../ReportBlockPreview'

/** @param {import('./CustomTextPreview.types').CustomTextPreviewProps} props */
export const CustomTextPreview = ({ document }) => {
  const renderers = {
    paragraph,
    heading,
    bulletList,
    horizontalRule
  }

  return (
    <ReportBlockPreview>
      {document?.content?.map((node, index) => {
        const { type, content, attrs, id } = node
        const render = renderers[type]

        if (!render) return null

        return <div key={id ?? index}>{render(content, attrs)}</div>
      })}
    </ReportBlockPreview>
  )
}

const heading = (text, { level }) => {
  const types = [<h1>{marks(text)}</h1>, <h2>{marks(text)}</h2>, <h3>{marks(text)}</h3>, <h4>{marks(text)}</h4>]
  return types[level - 1]
}

const marks = (content) => {
  return content?.map(({ text, marks }) => (marks ? <b>{text}</b> : text))
}

const paragraph = (content) => {
  return <p>{marks(content)}</p>
}

const bulletList = (content) => {
  return (
    <ul>
      {content.map((subDocument, i) => (
        <li key={i}>{<CustomTextPreview document={subDocument} />}</li>
      ))}
    </ul>
  )
}

const horizontalRule = () => {
  return <hr></hr>
}
